import { colors, typography } from '@everlywell/leaves';
import styled from 'styled-components';

export const Wrapper = styled.div`
  color: ${colors.gray5};
  font-weight: ${typography.weight.book};

  a {
    color: ${colors.teal5};
    text-decoration: none;
    font-weight: ${typography.weight.regular};

    a:hover,
    a:active {
      text-decoration: underline;
    }
  }
`;
